import { action, computed, observable, makeObservable } from 'mobx';
import MainStore from '.';
import Context from '../components/ui/Context';
import MenuStore from './MenuStore';

export default class BacktestingStore {
    mainStore: MainStore;
    menuStore: MenuStore;
    isOpen = false;

    constructor(mainStore: MainStore) {
        makeObservable(this, {
            context: computed,
            isOpen: observable,
            toggle: action.bound,
        });

        this.mainStore = mainStore;
        this.menuStore = new MenuStore(mainStore, { route: 'backtesting' });
    }

    get context(): Context | null {
        return this.mainStore.chart.context;
    }

    toggle() {
        this.isOpen = !this.isOpen;
        console.log('[BacktestingStore] Toggle clicked, isOpen:', this.isOpen);
    }
}
